<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <template v-if="isQuoteField">
    <jw-input-number disabled class="system-form-item-fields computed-fields ly-form-item-fields-disabled" v-model="modulesItem.fieldValue" :placeholder="quoteFieldPlaceholder" :formatter="(event) => isShowThousandFormatter(event, modulesItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(modulesItem, precisionNum, true)" />
  </template>

  <template v-else-if="isFormat">
    <!-- 精度 末尾不省略0 -->
    <jw-input-number ref="inputNumberRef" :disabled="modulesItem.businessData == '0' || disabledAll" @blur="handleChange" class="system-form-item-fields" v-model="modulesItem.fieldValue" :placeholder="modulesItem?.placeholder || ''" @input="(event) => getPrecisionNum(event, modulesItem)" @focus="clearUploadActive" :precision="tools.isJSON(modulesItem?.setting?.fieldExt) ? Number(JSON.parse(modulesItem?.setting?.fieldExt)?.numberFormat) : Number(modulesItem?.setting?.fieldExt)" />
  </template>
  <!-- 精度 末尾省略0 -->
  <template v-else>
    <jw-input-number :disabled="modulesItem.businessData == '0' || disabledAll" @focus="handleFocus" class="system-form-item-fields" v-model="modulesItem.fieldValue" :placeholder="modulesItem?.placeholder || ''" :formatter="(event) => isShowThousandFormatter(event, modulesItem)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(modulesItem, precisionNum)" />
  </template>
</template>

<script setup>
import { tools } from '@/utils/tools';
import { ref, nextTick, inject } from 'vue';
// 精度
import useThousandOption from '@/hooks/thousand';
import { useUploadStore } from '@/store';
const isQuoteField = inject('fhFormFieldsParams')?.isQuoteField;
const quoteFieldPlaceholder = inject('fhFormFieldsParams')?.quoteFieldPlaceholder;

const uploadStore = useUploadStore();
// 处理精度 千分符
const { isShowThousandFormatter, getPrecisionNum, getPrecision, precisionNum } = useThousandOption();
const emits = defineEmits(['cb']);

const props = defineProps({
  modules: {
    type: Object,
    default: () => {}
  },
  disabledAll: {
    type: Boolean,
    default: false
  }
});

const isFormat = ref(false);
const inputNumberRef = ref();
const clearUploadActive = () => {
  uploadStore.clearActive();
};
const handleFocus = () => {
  isFormat.value = true;
  nextTick(() => {
    inputNumberRef.value?.focus();
  });
  clearUploadActive();
};

const modulesItem = ref(props?.modules);
const handleChange = () => {
  isFormat.value = false;
  emits('cb', modulesItem.value);
};
</script>
